<template>
	<div
		:class="{
			'bg-fill-secondary rounded-xl': showStatus,
			'pointer-events-none opacity-60': disabled
		}"
	>
		<div :class="{ 'p-0.5': showStatus }">
			<BaseCard
				class="flex items-center gap-4"
				:class="{
					'py-2 pr-5 pl-2': !alt,
					'rounded-[10px]!': showStatus,
					'py-1.5 pr-4.5 pl-1.5': !alt && showStatus
				}"
			>
				<ItemIcon :src="src" :name="name" :preloader="preloader || undefined" />
				<div class="min-w-0 flex-1">
					<div
						class="text-label-secondary truncate text-xs font-medium uppercase"
					>
						{{ collection }}
					</div>
					<div class="text-label-primary mt-1 truncate text-sm font-medium">
						{{ name }}
					</div>
				</div>
				<CoinPrice :price="price" />
				<LoaderIcon class="h-5 w-5 text-white opacity-30" v-if="claiming" />
				<WarningIcon class="text-yellow h-5 w-5" v-if="error" />
				<slot v-if="!error && !claiming" />
			</BaseCard>
		</div>
		<div
			class="flex items-center justify-between px-4 pt-2.5 pb-3"
			v-if="showStatus"
		>
			<div class="text-label-secondary text-sm">
				{{ statusText }}
			</div>
			<div
				class="text-label-tertiary text-sm font-medium"
				@click="retry"
				v-if="error"
				v-hover="{ active: 'scale-90' }"
			>
				{{ t('retry') }}
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import CoinPrice from './CoinPrice.vue'
import BaseCard from './BaseCard.vue'
import LoaderIcon from '@/assets/icons/loader.svg'
import ItemIcon from './ItemIcon.vue'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import WarningIcon from '@/assets/icons/warning.svg'

const { t } = useI18n({
	messages: {
		en: {
			processing: 'Processing claim request...',
			error: 'Claim failed',
			unavailable: 'Gift is out of stock',
			retry: 'Retry'
		},
		ru: {
			processing: 'Обрабатываем запрос на вывод...',
			error: 'Ошибка при выводе',
			unavailable: 'Гифт закончился',
			retry: 'Повторить'
		}
	}
})

const props = defineProps<{
	error?:
		| 'UNAVAILABLE'
		| 'PRICE_MISMATCH'
		| 'INTERNAL_ERROR'
		| 'BOT_INTERACTION_REQUIRED'
	claiming?: boolean
	alt?: boolean
	src: string
	collection: string
	name: string
	price: number
	preloader?: string | null
	disabled?: boolean
}>()

const emit = defineEmits<{
	(e: 'retry'): void
}>()

const showStatus = computed(() => {
	return props.claiming || props.error
})

const retry = () => {
	emit('retry')
}

const statusText = computed(() => {
	if (!props.error) {
		return t('processing')
	}
	if (['UNAVAILABLE', 'PRICE_MISMATCH'].includes(props.error)) {
		return t('unavailable')
	}

	return t('error')
})
</script>
